import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@bibliocommons/base-buttons';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { composeEvent, composeAnalytics } from 'app/helpers/analytics/compose';

const { EVENTS, CATEGORIES, ACTIONS, CUSTOM_DIMENSIONS } = AnalyticsConstants;

export default function FulfilmentButton({ modalActions, modalKey, provider }) {
  function handleOpen() {
    sendAnalyticsEvents(
      composeAnalytics([
        composeEvent(EVENTS.DIGITAL_ACCESS, {
          gtmCategory: CATEGORIES.CHECKOUTS,
          gtmAction: ACTIONS.ACCESS,
          gtmLabel: provider,
          gtmValue: 1,
          gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ITEM
        })
      ])
    );
    modalActions.openModal(modalKey, { accountRequired: true });
  }

  return (
    <Button className="cp-fulfilment-button" handleClick={handleOpen} dataKey="fulfilment-button">
      <FormattedMessage id="access_this_item" />
    </Button>
  );
}

FulfilmentButton.propTypes = {
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalKey: PropTypes.string.isRequired,
  provider: PropTypes.string
};
